import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Help = () => {
  return (
    <div className='more_help_wrapper d-flex justify-content-center flex-column pl-4'>
        <Row>
            <Col md={5}>
                <h2>Need More Help?</h2>
                <p>We are always here to help, from ring sizing guides, to metal advice, you can find all the additional information here.</p>
                <Link className="edu-btn btn" to="/contact">Contact us</Link>
            </Col>
        </Row>
    </div>
  )
}

export default Help;